import React from "react";
import {
  Box,
  TextField,
  FormControl,
  InputAdornment,
  InputLabel,
  Input,
  IconButton,
  Button,
  Typography,
  Select,
  MenuItem,
  FormHelperText,
  Alert,
} from "@mui/material";
import {
  AccountCircleOutlined,
  Visibility,
  VisibilityOff,
  LockOutlined,
  Group,
} from "@mui/icons-material";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { set } from "lodash";
import { Tabs } from "../../../components/tabs";
import { Grid } from "../../../components/table";
import { CONFIG } from "../../../../config";
import axios from "axios";
import { ToolBar } from "../../../components/toolbar";
import { Modal } from "../../../components/modal";
import { FormA } from "../../../components/form";
import moment from "moment";
import { getFormState } from "../../../../helpers/form";
import dayjs from "dayjs";
import IosShareIcon from "@mui/icons-material/IosShare";

// use debounce
import { useDebouncedCallback } from "use-debounce";

const API_HOST = CONFIG.modules["accounts"].host;
const API_HOST_CRM = CONFIG.modules["crm"].host;

const sankalpColumnObj = {
  // motherId: {
  //     type: String,
  // },
  // agentName: {
  //     type: String
  // },
  // agentId: {
  //     type: String
  // },
  // data: {
  //     type: Object
  // },
  // callType: {
  //     type: String
  // },
  // phoneNo: {
  //     type: String
  // },
  // deleted: {
  //     type: Boolean,
  //     default: false
  // },
  //all columns
  wrongDetails: {
    type: String,
  },
  callDuration: {
    type: Number,
  },
  "agent.createdAt": {
    type: Date,
  },
  "agent.name": {
    type: String,
  },
  "agent._id": {
    type: String,
  },
  "agent.designation": {
    type: String,
  },
  "agent.type": {
    type: String,
  },
  "agent.email": {
    type: String,
  },
  "agent.phoneNo": {
    type: String,
  },
  "agent.username": {
    type: String,
  },
  "agent.updatedAt": {
    type: String,
  },
  advice: {
    type: String,
  },
  pregnancyNumber: {
    type: Number,
  },
  grievances: {
    type: String,
  },
  dataCorrection: {
    type: String,
  },
  familyPlanSugg: {
    type: String,
  },

  createdAt: {
    type: Date,
  },
  internalMotherId: {
    type: String,
  },
  singleMother: {
    type: String,
  },
  pretermDelivery: {
    type: String,
  },
  callStatus: {
    type: String,
  },
  __v: {
    type: String,
  },
  _pk_id: {
    type: String,
  },
  callerType: {
    type: String,
  },
  languageBucket: {
    type: String,
  },
  childUnder1: {
    type: String,
  },
  highRisk: {
    type: String,
  },
  updatedAt: {
    type: Date,
  },
  "motherDetails.Mother Details.MOTHER ID": {
    type: String,
  },
  "motherDetails.Mother Details.SC near residence": {
    type: String,
  },
  "motherDetails.Mother Details.Current Pregnancy Trimester": {
    type: String,
  },
  "motherDetails.Mother Details.residence Village": {
    type: String,
  },
  "motherDetails.Mother Details.residence Block": {
    type: String,
  },
  "motherDetails.Mother Details.residence District": {
    type: String,
  },
  "motherDetails.EDD": {
    type: Date,
  },
  "motherDetails.Age of Woman": {
    type: Number,
  },
  "motherDetails.Registration Details.Age Height Group.Age of the Woman": {
    type: Number,
  },

  "motherDetails.Registration Details.Order of Pregnancy": {
    type: String,
  },
  "motherDetails.Pregnancy Serial number": {
    type: Number,
  },
  "motherDetails.High Risk Case": {
    type: String,
  },
  "motherDetails.Delivery.Was there any complication during delivery": {
    type: String,
  },
  "motherDetails.Delivery.Children Delivered Group.Number of children delivered":
    {
      type: Number,
    },
  "motherDetails.Delivery.Children Delivered Group.number_of_live_births": {
    type: Number,
  },
  "motherDetails.Delivery.Delivery Details.Actual Date of Delivery": {
    type: Date,
  },
  "motherDetails.Delivery.Delivery Details.Actual Location of the Delivery": {
    type: String,
  },
  "motherDetails.Delivery.Delivery Details.Actual Date of Delivery LOV": {
    type: Date,
  },
  "motherDetails.Delivery.Who conducted the Delivery": {
    type: String,
  },
  "motherDetails.Pregnancy Group ID": {
    type: String,
  },
  "motherDetails.LMP": {
    type: Date,
  },
  comments: {
    type: String,
  },
  familyPlanWilling: {
    type: String,
  },

  child1to2: {
    type: String,
  },
  emergencyCase: {
    type: String,
  },
  childCount: {
    type: Number,
  },

  isLastCall: {
    type: String,
  },
  queries: {
    type: String,
  },
  birthDefects: {
    type: String,
  },

  callEnd: {
    type: Date,
  },
  deliveryPlace: {
    type: String,
  },
  childImmunized: {
    type: String,
  },
  pregStatus: {
    type: String,
  },
  callNumberLOV: {
    type: Number,
  },

  callDateTime: {
    type: Date,
  },
  callInstance: {
    type: Number,
  },
  callNumber: {
    type: Number,
  },
  doneCallInstance: {
    type: Number,
  },
  multiParties: {
    type: String,
  },
  referred: {
    type: String,
  },
  callerName: {
    type: String,
  },
  "motherDetails.Parameters Programmes for Institutional Delivery.PID.Intervention Action plan of Medical Officer":
    {
      type: String,
    },
  "motherDetails.Parameters Programmes for Institutional Delivery.PID.Is she ready to deliver her baby at the facility":
    {
      type: String,
    },
  pregStatusInMonths: {
    type: String,
  },
  callNotDoneReason: {
    type: String,
  },
  "motherDetails.Past Obstetric History.GPADL.Number of Abortions": {
    type: Number,
  },
  "motherDetails.Past Obstetric History.GPADL.Gravida": {
    type: Number,
  },
  "motherDetails.Past Obstetric History.GPADL.Number of Child Deaths": {
    type: Number,
  },
  homeDeliveryReasons: {
    type: String,
  },
  "motherDetails.Delivery.What was the Complication during delivery": {
    type: String,
  },
  pregnancyQueries: {
    type: String,
  },
  otherGrievances: {
    type: String,
  },
  otherQueries: {
    type: String,
  },
  immunizeReason: {
    type: String,
  },
  otherImmunizeReason: {
    type: String,
  },
  otherHomeDeliveryReason: {
    type: String,
  },
  otherBirthDefects: {
    type: String,
  },
  motherEmergencyQueries: {
    type: String,
  },
  postDeliveryQueries: {
    type: String,
  },
  childHealthQueries: {
    type: String,
  },
  pendingCallDateTime: {
    type: Date,
  },
};

// This will be harcoded
// function for modifying the column names
const modifiedLabelWithDot = (key) => {
  // logic for motherDetails.Mother
  // if has motherDetails.Mother
  if (key.startsWith("motherDetails.Mother")) {
    let temp = key.split(" ");
    temp = temp.slice(2);

    if (temp.length > 1) {
      temp[0] = temp[0][0].toUpperCase() + temp[0].slice(1);
      temp = temp.join(" ");

      return temp;
    }

    return temp[0][0].toUpperCase() + temp[0].slice(1);
  }

  // for mother details registration
  if (
    key.startsWith(
      "motherDetails.Registration Details.Age Height Group.Age of the Woman"
    )
  ) {
    return "Age of the Woman";
  }

  if (key.startsWith("motherDetails.Registration Details.Order of Pregnancy")) {
    return "Order of Pregnancy";
  }

  // for mother details Details
  if (key.startsWith("motherDetails.Delivery")) {
    let temp = key.split(".");
    // slice the temp to 2 index
    temp = temp.slice(2);

    // check if temp length is greater then 1
    if (temp.length > 1) {
      // check if it consist of underscore;
      if (temp[temp.length - 1].includes("_")) {
        return temp[temp.length - 1]
          .split("_")
          .map((s) => s[0].toUpperCase() + s.slice(1))
          .join(" ");
      } else {
        return temp[temp.length - 1];
      }
    }
    // if not return temp[0]

    return temp[0];
  }

  // if key starts with motherDetails.Paramters
  if (key.startsWith("motherDetails.Parameters")) {
    let temp = key.split(".");

    return temp[3];
  }

  // if key starts with motherDetails.Past
  if (key.startsWith("motherDetails.Past")) {
    let temp = key.split(".");

    return temp[3];
  }

  if (key.startsWith("motherDetails")) {
    let temp = key.split(".");

    return temp[1];
  }

  if (key === "advice") {
    return key[0].toUpperCase() + key.slice(1);
  }

  if (key === "pregnancyNumber") {
    return "Pregnancy Number";
  }

  if (key.includes(".")) {
    return key
      .split(".")
      .map((k) => k[0].toUpperCase() + k.slice(1))
      .join(" ");
  }
  key = key[0].toUpperCase() + key.slice(1);
  let lastkeylogic = key.replace(/([A-Z]+)/g, " $1");
  return lastkeylogic;

  return key;
};

const MonthsPregStatus = [
  "First",
  "Second",
  "Third",
  "Fourth",
  "Fifth",
  "Sixth",
  "Seventh",
  "Eighth",
  "Ninth",
];

export const SankalpList = (props) => {
  const {
    roles,
    user,
    users,
    Designations,
    Departments,
    Languages,
    Districts,
  } = useSelector((state) => state.user || {});
  const userStore = useSelector((state) => state.user || {});

  useEffect(() => {
    console.log("districts", Districts);
    console.log("Language", Languages);
  }, [Districts]);

  const [active, setActive] = useState("Employees");
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [action, setAction] = useState("new");
  const [saved, setSaved] = useState(null);
  const [index, setIndex] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [count, setCount] = useState(0);
  const [filter, setFilter] = useState({
    from: dayjs("01-01-2023"),
    to: dayjs(),
  });

  // debounced logic
  const debounced = useDebouncedCallback(
    // function
    (value) => {
      setFilter({ ...value });
    },
    // delay in ms
    1000
  );

  // const getList = () => {
  //     setData([])
  //     axios.get(API_HOST_CRM + `/cases?sankalp=yes&limit=${rowsPerPage}&page=${page}${
  //         filter.from?`&from=${dayjs(filter.from).format('YYYY-MM-DD')}`:''
  //         }${filter.to?`&to=${dayjs(filter.to).format('YYYY-MM-DD')}`:''}
  //         ${filter.status?`&status=${filter.status}`:''}
  //         `)
  //     .then((resp) => {
  //         if (resp.data && resp.data.success) {
  //             setData(resp.data.cases)
  //             setCount(resp.data.count)
  //         }

  //     }).catch((e) => {

  //         console.log(e)
  //     })
  // }

  const filterQueryStringCreator = (filter) => {
    let queryString = "";
    if (filter.motherId) {
      queryString += `&motherId=${filter.motherId}`;
    }

    if (filter.agent_phoneNo) {
      queryString += `&agent_phoneNo=${filter.agent_phoneNo}`;
    }

    if (filter.agent_name) {
      queryString += `&agent_name=${filter.agent_name}`;
    }

    if (filter.district) {
      queryString += `&motherDetails_Mother_Details_residence_District=${filter.district}`;
    }

    if (filter.callDuration) {
      queryString += `&callDuration=${filter.callDuration}`;
    }

    if (filter.callNotDoneReason) {
      queryString += `&callNotDoneReason=${filter.callNotDoneReason}`;
    }

    if (filter.agent_designation) {
      queryString += `&agent_designation=${filter.agent_designation}`;
    }

    if (filter.advice) {
      queryString += `&advice=${filter.advice}`;
    }

    // grievances
    if (filter.grievances) {
      queryString += `&grievances=${filter.grievances}`;
    }

    // data correction
    if (filter.dataCorrection) {
      queryString += `&dataCorrection=${filter.dataCorrection}`;
    }

    // family plan sugg
    if (filter.familyPlanSugg) {
      queryString += `&familyPlanSugg=${filter.familyPlanSugg}`;
    }

    // single mother
    if (filter.singleMother) {
      queryString += `&singleMother=${filter.singleMother}`;
    }

    // caller Type
    if (filter.callerType) {
      queryString += `&callerType=${filter.callerType}`;
    }

    // languageBucket
    if (filter.languageBucket) {
      queryString += `&languageBucket=${filter.languageBucket}`;
    }

    // childUnder1
    if (filter.childUnder1) {
      queryString += `&childUnder1=${filter.childUnder1}`;
    }
    // high risk
    if (filter.highRisk) {
      queryString += `&highRisk=${filter.highRisk}`;
    }

    // motherDetails_Mother_Details_SC_near_residence
    if (filter.motherDetails_Mother_Details_SC_near_residence) {
      queryString += `&motherDetails_Mother_Details_SC_near_residence=${filter.motherDetails_Mother_Details_SC_near_residence}`;
    }
    //motherDetails_Mother_Details_Current_Pregnancy_Trimester
    if (filter.motherDetails_Mother_Details_Current_Pregnancy_Trimester) {
      queryString += `&motherDetails_Mother_Details_Current_Pregnancy_Trimester=${filter.motherDetails_Mother_Details_Current_Pregnancy_Trimester}`;
    }

    //motherDetails_Mother_Details_residence_Village
    if (filter.motherDetails_Mother_Details_residence_Village) {
      queryString += `&motherDetails_Mother_Details_residence_Village=${filter.motherDetails_Mother_Details_residence_Village}`;
    }

    // motherDetails_Mother_Details_residence_Block
    if (filter.motherDetails_Mother_Details_residence_Block) {
      queryString += `&motherDetails_Mother_Details_residence_Block=${filter.motherDetails_Mother_Details_residence_Block}`;
    }

    // motherDetails_Age_of_Woman
    if (filter.motherDetails_Age_of_Woman) {
      queryString += `&motherDetails_Age_of_Woman=${filter.motherDetails_Age_of_Woman}`;
    }

    // motherDetails_Registration_Details_Age_Height_Group_Age_of_the_Woman
    if (
      filter.motherDetails_Registration_Details_Age_Height_Group_Age_of_the_Woman
    ) {
      queryString += `&motherDetails_Registration_Details_Age_Height_Group_Age_of_the_Woman=${filter.motherDetails_Registration_Details_Age_Height_Group_Age_of_the_Woman}`;
    }

    //  motherDetails_Registration_Details_Order_of_Pregnancy
    if (filter.motherDetails_Registration_Details_Order_of_Pregnancy) {
      queryString += `&motherDetails_Registration_Details_Order_of_Pregnancy=${filter.motherDetails_Registration_Details_Order_of_Pregnancy}`;
    }

    // motherDetails_Pregnancy_Serial_number
    if (filter.motherDetails_Pregnancy_Serial_number) {
      queryString += `&motherDetails_Pregnancy_Serial_number=${filter.motherDetails_Pregnancy_Serial_number}`;
    }

    // motherDetails_High_Risk_Case
    if (filter.motherDetails_High_Risk_Case) {
      queryString += `&motherDetails_High_Risk_Case=${filter.motherDetails_High_Risk_Case}`;
    }

    //  motherDetails_Delivery_Was_there_any_complication_during_delivery
    if (
      filter.motherDetails_Delivery_Was_there_any_complication_during_delivery
    ) {
      queryString += `&motherDetails_Delivery_Was_there_any_complication_during_delivery=${filter.motherDetails_Delivery_Was_there_any_complication_during_delivery}`;
    }

    // motherDetails_Delivery_Children_Delivered_Group_Number_of_children_delivered
    if (
      filter.motherDetails_Delivery_Children_Delivered_Group_Number_of_children_delivered
    ) {
      queryString += `&motherDetails_Delivery_Children_Delivered_Group_Number_of_children_delivered=${filter.motherDetails_Delivery_Children_Delivered_Group_Number_of_children_delivered}`;
    }

    //  motherDetails_Delivery_Children_Delivered_Group_number_of_live_births
    if (
      filter.motherDetails_Delivery_Children_Delivered_Group_number_of_live_births
    ) {
      queryString += `&motherDetails_Delivery_Children_Delivered_Group_number_of_live_births=${filter.motherDetails_Delivery_Children_Delivered_Group_number_of_live_births}`;
    }
    // motherDetails_Delivery_Delivery_Details_Actual_Date_of_Delivery_LOV
    if (
      filter.motherDetails_Delivery_Delivery_Details_Actual_Date_of_Delivery_LOV
    ) {
      queryString += `&motherDetails_Delivery_Delivery_Details_Actual_Date_of_Delivery_LOV=${filter.motherDetails_Delivery_Delivery_Details_Actual_Date_of_Delivery_LOV}`;
    }

    // motherDetails_Delivery_Delivery_Details_Actual_Location_of_the_Delivery
    if (
      filter.motherDetails_Delivery_Delivery_Details_Actual_Location_of_the_Delivery
    ) {
      queryString += `&motherDetails_Delivery_Delivery_Details_Actual_Location_of_the_Delivery=${filter.motherDetails_Delivery_Delivery_Details_Actual_Location_of_the_Delivery}`;
    }

    // motherDetails_Delivery_Who_conducted_the_Delivery
    if (filter.motherDetails_Delivery_Who_conducted_the_Delivery) {
      queryString += `&motherDetails_Delivery_Who_conducted_the_Delivery=${filter.motherDetails_Delivery_Who_conducted_the_Delivery}`;
    }

    // comments
    if (filter.comments) {
      queryString += `&comments=${filter.comments}`;
    }

    // family plan willing
    if (filter.familyPlanWilling) {
      queryString += `&familyPlanWilling=${filter.familyPlanWilling}`;
    }

    // child1to2
    if (filter.child1To2) {
      queryString += `&child1To2=${filter.child1To2}`;
    }

    // emergencycase
    if (filter.emergencyCase) {
      queryString += `&emergencyCase=${filter.emergencyCase}`;
    }

    // child count
    if (filter.childCount) {
      queryString += `&childCount=${filter.childCount}`;
    }

    // query
    if (filter.queries) {
      queryString += `&queries=${filter.queries}`;
    }
    // birth defects
    if (filter.birthDefects) {
      queryString += `&birthDefects=${filter.birthDefects}`;
    }

    // multiParties
    if (filter.multiParties) {
      queryString += `&multiParties=${filter.multiParties}`;
    }

    // referred
    if (filter.referred) {
      queryString += `&referred=${filter.referred}`;
    }

    // preterm Delivery
    if (filter.pretermDelivery) {
      queryString += `&pretermDelivery=${filter.pretermDelivery}`;
    }

    // if call type
    if (filter.callType) {
      queryString += `&callType=${filter.callType}`;
    }

    // phone No
    if (filter.phoneNo) {
      queryString += `&phoneNo=${filter.phoneNo}`;
    }

    // callerName
    if (filter.callerName) {
      queryString += `&callerName=${filter.callerName}`;
    }

    // callNumberlOV
    if (filter.callNumberLOV) {
      queryString += `&callNumberLOV=${filter.callNumberLOV}`;
    }

    // motherDetails_Past_Obstetric_History_GPADL_Number_of_Abortions
    if (filter.motherDetails_Past_Obstetric_History_GPADL_Number_of_Abortions) {
      queryString += `&motherDetails_Past_Obstetric_History_GPADL_Number_of_Abortions=${filter.motherDetails_Past_Obstetric_History_GPADL_Number_of_Abortions}`;
    }
    //motherDetails_Past_Obstetric_History_GPADL_Gravida
    if (filter.motherDetails_Past_Obstetric_History_GPADL_Gravida) {
      queryString += `&motherDetails_Past_Obstetric_History_GPADL_Gravida=${filter.motherDetails_Past_Obstetric_History_GPADL_Gravida}`;
    }
    // motherDetails_Past_Obstetric_History_GPADL_Number_of_Child_Deaths
    if (
      filter.motherDetails_Past_Obstetric_History_GPADL_Number_of_Child_Deaths
    ) {
      queryString += `&motherDetails_Past_Obstetric_History_GPADL_Number_of_Child_Deaths=${filter.motherDetails_Past_Obstetric_History_GPADL_Number_of_Child_Deaths}`;
    }

    // pregStatusinMonths
    if (filter.pregStatusInMonths) {
      queryString += `&pregStatusInMonths=${filter.pregStatusInMonths}`;
    }

    // delivery Place
    if (filter.deliveryPlace) {
      queryString += `&deliveryPlace=${filter.deliveryPlace}`;
    }

    // call instance
    if(filter.callInstance) {
        queryString += `&callInstance=${filter.callInstance}`
    }

    // childImmunized
    if(filter.childImmunized){
        queryString += `&childImmunized=${filter.childImmunized}`
    }

    // homeDeliveryReasons
    if(filter.homeDeliveryReasons){
        queryString += `&homeDeliveryReasons=${filter.homeDeliveryReasons}`
    }

    // motherDetails_Parameters_Programmes_for_Institutional_Delivery_PID_Intervention_Action_plan_of_Medical_Officer
    if(filter.motherDetails_Parameters_Programmes_for_Institutional_Delivery_PID_Intervention_Action_plan_of_Medical_Officer){
        queryString += `&motherDetails_Parameters_Programmes_for_Institutional_Delivery_PID_Intervention_Action_plan_of_Medical_Officer=${filter.motherDetails_Parameters_Programmes_for_Institutional_Delivery_PID_Intervention_Action_plan_of_Medical_Officer}`
    }
    // motherDetails_Parameters_Programmes_for_Institutional_Delivery_PID_Is_she_ready_to_deliver_her_baby_at_the_facility
    if(filter.motherDetails_Parameters_Programmes_for_Institutional_Delivery_PID_Is_she_ready_to_deliver_her_baby_at_the_facility){
        queryString += `&motherDetails_Parameters_Programmes_for_Institutional_Delivery_PID_Is_she_ready_to_deliver_her_baby_at_the_facility=${filter.motherDetails_Parameters_Programmes_for_Institutional_Delivery_PID_Is_she_ready_to_deliver_her_baby_at_the_facility}`
    }

    // immunize Reason
    if(filter.immunizeReason){
        queryString += `&immunizeReason=${filter.immunizeReason}`
    }

    // otherImmunizeReason
    if(filter.otherImmunizeReason){
        queryString += `&otherImmunizeReason=${filter.otherImmunizeReason}`
    }

    // otherHomeDeliveryReason
    if(filter.otherHomeDeliveryReason){
        queryString += `&otherHomeDeliveryReason=${filter.otherHomeDeliveryReason}`
    }

    return queryString;
  };

  const getList = () => {
    setData([]);

    const filterQueryString = filterQueryStringCreator(filter);

    axios
      .get(
        API_HOST_CRM +
          `/get-sankalp?&limit=${rowsPerPage}&page=${page}${
            filter.from
              ? `&from=${dayjs(filter.from).format("YYYY-MM-DD")}`
              : ""
          }${filter.to ? `&to=${dayjs(filter.to).format("YYYY-MM-DD")}` : ""}
            ${
              filter.status ? `&status=${filter.status}` : ""
            }${filterQueryString}
            `
      )
      .then((resp) => {
        if (resp.data && resp.data.success) {
          setData(resp.data.cases);
          setCount(resp.data.count);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    const timeoutId = setTimeout(()=>{
        getList();
      }, 500)
      return ()=>{
        clearTimeout(timeoutId)
      }
   
  }, [page, rowsPerPage, filter]);

  useEffect(() => {
    getList();
  }, []);

  return (
    <>
      <ToolBar
        flex={"column"}
        height={"100%"}
        name={""}
        buttons={
          [
            // {
            //     name: 'Export',
            //     // type: 'chip',
            //     icon: () => <IosShareIcon sx={{ fontSize: '1.2em' }} />,
            //     onClick: () => {
            //     }
            // }
          ]
        }
        filters={[
        //   {
        
        //     field: {
        //       name: "status",
        //       type: "select",
        //       label: "Status",
        //       option: { key: "Status", value: "_id", label: "name" },
        //     },
        //     data: {
        //       Status: ["Any", "done", "notDone"].map((d) => ({
        //         _id: d,
        //         name: d,
        //       })),
        //     },
        //     onChange: (name, value) => {
        //       filter[name] = value;
        //       setFilter({ ...filter });
        //     },
        //     state: filter,
        //   },
          {
            field: {
              name: "from",
              type: "date",
              label: "From",
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          {
            field: {
              name: "to",
              type: "date",
              label: "To",
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          {
            field: {
              name: "motherId",
              type: "text",
              label: "Mother ID",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              //   debounced({ ...filter });
              // setFilter();
            },
            state: filter,
          },
          {
            field: {
              name: "phoneNo",
              type: "number",
              label: "Contact",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              //   debounced({ ...filter });
              // setFilter();
            },
            state: filter,
          },
          {
            minWidth: 160,
            field: {
              name: "pregStatusInMonths",
              type: "select",
              label: "Preg Status in Months",
              option: {
                key: "PregStatusInMonths",
                value: "_id",
                label: "name",
              },
            },
            data: {
              PregStatusInMonths: [
                { _id: "", name: "Any" },
                ...MonthsPregStatus.map((d) => {
                  if (d === "Any") return { _id: "", name: "Any" };
                  return { _id: d, name: d };
                }),
              ],
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          // district query
          {
            field: {
              name: "district",
              type: "select",
              label: "District",
              option: { key: "District", value: "_id", label: "name" },
            },
            data: {
              District: [
                { _id: "", name: "Any" },
                ...Districts.map((d) => {
                  if (d === "Any") return { _id: "", name: "Any" };
                  return { _id: d.name, name: d.name };
                }),
              ],
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          // call duration
          {
            field: {
              name: "callDuration",
              type: "number",
              label: "Call Duration",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              //   debounced({ ...filter });
              // setFilter();
            },
            state: filter,
          },
          {
            field: {
              name: "agent_name",
              type: "text",
              label: "Agent Name",
            },

            onChange: (name, value) => {
              filter[name] = value;
              debounced({ ...filter });
              // setFilter();
            },
            state: filter,
          },
          // call not done reasons
          {
            minWidth: 160,
            field: {
              name: "callNotDoneReason",
              type: "select",
              label: "Call Not Done Reason",
              option: { key: "CallNotDoneReason", value: "_id", label: "name" },
            },
            data: {
              CallNotDoneReason: [
                "Any",
                "Busy",
                "No Answer",
                "Call Incomplete",
                "Switch off",
                "No network",
                "Out of service",
                "Deceased Child",
                "Wrong number",
              ].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          // agent designation
          // should be a select but using text for now
          {
            field: {
              name: "agent_designation",
              type: "text",
              label: "Agent Designation",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              // setFilter();
            },
            state: filter,
          },
          {
            field: {
              name: "advice",
              type: "text",
              label: "Advice",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              // setFilter();
            },
            state: filter,
          },
          // grievances
          // should be a select but using text for now
          {
            field: {
              name: "grievances",
              type: "text",
              label: "Grievances",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              // setFilter();
            },
            state: filter,
          },

          // dataCorrection
          // should be a select but using text for now
          {
            field: {
              name: "dataCorrection",
              type: "text",
              label: "Data Correction",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              // setFilter();
            },
            state: filter,
          },

          // family Plan Sugg
          {
            minWidth: 160,
            field: {
              name: "familyPlanSugg",
              type: "select",
              label: "Family Plan Suggestion",
              option: { key: "FamilyPlanSuggest", value: "_id", label: "name" },
            },
            data: {
              FamilyPlanSuggest: ["Any", "Yes", "No"].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          // single mother
          {
            field: {
              name: "singleMother",
              type: "select",
              label: "Single Mother",
              option: { key: "SingleMother", value: "_id", label: "name" },
            },
            data: {
              SingleMother: ["Any", "Yes", "No"].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          // call Type
          // {
          //     field: {
          //       name: "callType",
          //       type: "select",
          //       label: "Call Type",
          //       option: { key: "CallType", value: "_id", label: "name" },
          //     },
          //     data: {
          //       CallType: [
          //         "Any",
          //         "outbound",
          //         "inbound"
          //       ].map((d) => {
          //         if (d === "Any") return { _id: "", name: "Any" };
          //         return { _id: d, name: d };
          //       }),
          //     },
          //     onChange: (name, value) => {
          //       filter[name] = value;
          //       setFilter({ ...filter });
          //     },
          //     state: filter,
          //   },
          // caller Type
          {
            field: {
              name: "callerType",
              type: "select",
              label: "Caller Type",
              option: { key: "CallerType", value: "_id", label: "name" },
            },
            data: {
              CallerType: [
                "Any",
                "ASHA",
                "Family member",
                "Beneficiary herself",
                "ANM",
              ].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          // callerName
          {
            field: {
              name: "callerName",
              type: "text",
              label: "Caller Name",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              // setFilter();
            },
            state: filter,
          },
          // callNumberLOV
          {
            field: {
              name: "callNumberLOV",
              type: "number",
              label: "Call Number LOV",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              // setFilter();
            },
            state: filter,
          },
             // callInstance
             {
                field: {
                  name: "callInstance",
                  type: "number",
                  label: "Call Instance",
                },
    
                onChange: (name, value) => {
                  filter[name] = value;
                  setFilter({ ...filter });
                  // setFilter();
                },
                state: filter,
              },
          // languageBucker
          {
            field: {
              name: "languageBucket",
              type: "select",
              label: "Language Bucket",
              option: { key: "LanguageBucket", value: "_id", label: "name" },
            },
            data: {
              LanguageBucket: [
                { _id: "", name: "Any" },
                ...Languages.map((l) => ({ _id: l.name, name: l.name })),
              ],
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          // child under 1
          {
            field: {
              name: "childUnder1",
              type: "select",
              label: "Child Under 1",
              option: { key: "ChildUnder1", value: "_id", label: "name" },
            },
            data: {
              ChildUnder1: ["Any", "Yes", "No"].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          // highRisk
          {
            field: {
              name: "highRisk",
              type: "select",
              label: "High Risk",
              option: { key: "HighRisk", value: "_id", label: "name" },
            },
            data: {
              HighRisk: ["Any", "Yes", "No"].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },

          // near residence
          // dataCorrection
          // should be a select but using text for now
          {
            field: {
              name: "motherDetails_Mother_Details_SC_near_residence",
              type: "text",
              label: "Near Residence",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              // setFilter();
            },
            state: filter,
          },

          // highRisk
          {
            minWidth: 200,
            field: {
              name: "motherDetails_Mother_Details_Current_Pregnancy_Trimester",
              type: "select",
              label: "Current Pregnancy Trimester",
              option: {
                key: "CurrentPregnancyTrimester",
                value: "_id",
                label: "name",
              },
            },
            data: {
              CurrentPregnancyTrimester: [
                "Any",
                "Overdue",
                "2nd Trimester",
                "3rd Trimester",
              ].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          // mother details residence village
          {
            field: {
              name: "motherDetails_Mother_Details_residence_Village",
              type: "text",
              label: "Residence Village",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              // setFilter();
            },
            state: filter,
          },

          // residence block
          // mother details residence village
          {
            field: {
              name: "motherDetails_Mother_Details_residence_Block",
              type: "text",
              label: "Residence Block",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              // setFilter();
            },
            state: filter,
          },

          // motherDetails_Age_of_Woman
          {
            field: {
              name: "motherDetails_Age_of_Woman",
              type: "number",
              label: "Age of Woman",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              // setFilter();
            },
            state: filter,
          },
          // motherDetails_Age_of_Woman
          {
            field: {
              name: "motherDetails_Age_of_Woman",
              type: "number",
              label: "Age of Woman",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              // setFilter();
            },
            state: filter,
          },

          // motherDetails_Registration_Details_Age_Height_Group_Age_of_the_Woman
          {
            field: {
              name: "motherDetails_Registration_Details_Age_Height_Group_Age_of_the_Woman",
              type: "number",
              label: "Registered Age of Woman",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              // setFilter();
            },
            state: filter,
          },

          // order of pregnancy
          {
            minWidth: 150,
            field: {
              name: "motherDetails_Registration_Details_Order_of_Pregnancy",
              type: "select",
              label: "Order of Pregnancy",
              option: { key: "OrderOfPregnancy", value: "_id", label: "name" },
            },
            data: {
              OrderOfPregnancy: [
                "Any",
                "1st",
                "2nd",
                "3rd",
                "4th",
                "More than 4",
              ].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },

          // mother serial number
          {
            field: {
              name: "motherDetails_Pregnancy_Serial_number",
              type: "number",
              label: "Mother Serial Number",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              // setFilter();
            },
            state: filter,
          },
          // motherDetails_High_Risk_Case
          {
            field: {
              name: "motherDetails_High_Risk_Case",
              type: "select",
              label: "High Risk Case",
              option: {
                key: "motherDetails_High_Risk_Case",
                value: "_id",
                label: "name",
              },
            },
            data: {
              motherDetails_High_Risk_Case: ["Any", "Yes", "No"].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },

          //  motherDetails_Delivery_Was_there_any_complication_during_delivery
          {
            minWidth: 200,
            field: {
              name: "motherDetails_Delivery_Was_there_any_complication_during_delivery",
              type: "select",
              label: "Complications During Delivery",
              option: {
                key: "ComplicationDuringDelivery",
                value: "_id",
                label: "name",
              },
            },
            data: {
              ComplicationDuringDelivery: ["Any", "Yes", "No"].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },

          //motherDetails_Delivery_Children_Delivered_Group_Number_of_children_delivered
          {
            field: {
              name: "motherDetails_Delivery_Children_Delivered_Group_Number_of_children_delivered",
              type: "number",
              label: "Number of children delivered",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              // setFilter();
            },
            state: filter,
          },
          // motherDetails_Delivery_Children_Delivered_Group_number_of_live_births
          {
            field: {
              name: "motherDetails_Delivery_Children_Delivered_Group_number_of_live_births",
              type: "number",
              label: "Number of Livebirths",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              // setFilter();
            },
            state: filter,
          },

          //motherDetails_Delivery_Delivery_Details_Actual_Date_of_Delivery_LOV
          {
            field: {
              name: "motherDetails_Delivery_Delivery_Details_Actual_Date_of_Delivery_LOV",
              type: "text",
              label: "Actual Date of Delivery",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              // setFilter();
            },
            state: filter,
          },
          // motherDetails_Delivery_Delivery_Details_Actual_Location_of_the_Delivery
          {
            field: {
              name: "motherDetails_Delivery_Delivery_Details_Actual_Location_of_the_Delivery",
              type: "text",
              label: "Actual Location of the Delivery",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              // setFilter();
            },
            state: filter,
          },

          // motherDetails_Delivery_Who_conducted_the_Delivery
          {
            minWidth: 200,
            field: {
              name: "motherDetails_Delivery_Who_conducted_the_Delivery",
              type: "select",
              label: "Who Conducted Delivery",
              option: {
                key: "WhoConductedDelivery",
                value: "_id",
                label: "name",
              },
            },
            data: {
              WhoConductedDelivery: [
                "Any",
                "Medical Officer",
                "Staff Nurse",
                "ANM",
                "Dai - Skilled Birth Attendant",
                "Others",
              ].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },

          // comments
          {
            field: {
              name: "comments",
              type: "text",
              label: "Comments",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              // setFilter();
            },
            state: filter,
          },
          // familyPlanWilling
          {
            minWidth: 150,
            field: {
              name: "familyPlanWilling",
              type: "select",
              label: "Willing For Family Plan",
              option: {
                key: "FamilyPlanWilling",
                value: "_id",
                label: "name",
              },
            },
            data: {
              FamilyPlanWilling: ["Any", "Maybe", "Yes", "No"].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          // child1To2
          {
            field: {
              name: "child1To2",
              type: "select",
              label: "Child 1 To 2",
              option: {
                key: "Child1To2",
                value: "_id",
                label: "name",
              },
            },
            data: {
              Child1To2: ["Any", "Yes", "No"].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          // child1To2
          {
            field: {
              name: "emergencyCase",
              type: "select",
              label: "Emergency Case",
              option: {
                key: "EmergencyCase",
                value: "_id",
                label: "name",
              },
            },
            data: {
              EmergencyCase: ["Any", "Yes", "No"].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          // comments
          {
            field: {
              name: "childCount",
              type: "number",
              label: "Child Count",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
              // setFilter();
            },
            state: filter,
          },
          // queries
          {
            field: {
              name: "queries",
              type: "select",
              label: "Queries",
              option: {
                key: "Query",
                value: "_id",
                label: "name",
              },
            },
            data: {
              Query: ["Any", "None", "Child health related"].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },

          // birthDefects
          {
            field: {
              name: "birthDefects",
              type: "select",
              label: "Birth Defects",
              option: {
                key: "BirthDefect",
                value: "_id",
                label: "name",
              },
            },
            data: {
              BirthDefect: ["Any", "None", "Others"].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                if (d === "Others")
                  return { _id: "Others (Please specify)", name: "Others" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          // multiParties
          {
            field: {
              name: "multiParties",
              type: "select",
              label: "Multi Parties",
              option: {
                key: "MultiParties",
                value: "_id",
                label: "name",
              },
            },
            data: {
              MultiParties: ["Any", "Yes", "No"].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },

          // referred
          {
            field: {
              name: "referred",
              type: "select",
              label: "Referred",
              option: {
                key: "Referred",
                value: "_id",
                label: "name",
              },
            },
            data: {
              Referred: ["Any", "Yes", "No"].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },

          // pretermDelivery
          {
            field: {
              name: "pretermDelivery",
              type: "select",
              label: "Preterm Delivery",
              option: {
                key: "PretermDelivery",
                value: "_id",
                label: "name",
              },
            },
            data: {
              PretermDelivery: ["Any", "Yes", "No"].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          // Number of abortions
          {
            field: {
              name: "motherDetails_Past_Obstetric_History_GPADL_Number_of_Abortions",
              type: "number",
              label: "Number of Abortions",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          //Gravida
          {
            field: {
              name: "motherDetails_Past_Obstetric_History_GPADL_Gravida",
              type: "number",
              label: "Gravida",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },

          //Number of child deaths
          {
            field: {
              name: "motherDetails_Past_Obstetric_History_GPADL_Number_of_Child_Deaths",
              type: "number",
              label: "Number of Child Deaths",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },

          // deliveryPlace
          {
            field: {
              name: "deliveryPlace",
              type: "select",
              label: "Delivery Place",
              option: {
                key: "DeliveryPlace",
                value: "_id",
                label: "name",
              },
            },
            data: {
              DeliveryPlace: [
                "Any",
                "Home Delivery",
                "Institutional Delivery",
              ].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
            // childImmunized
            {
                field: {
                  name: "childImmunized",
                  type: "select",
                  label: "Child Immunized",
                  option: {
                    key: "ChildImmunized",
                    value: "_id",
                    label: "name",
                  },
                },
                data: {
                  ChildImmunized: [
                    "Any",
                    "Yes",
                    "No",
                  ].map((d) => {
                    if (d === "Any") return { _id: "", name: "Any" };
                    return { _id: d, name: d };
                  }),
                },
                onChange: (name, value) => {
                  filter[name] = value;
                  setFilter({ ...filter });
                },
                state: filter,
              },
              
          //home Deliery reasons
          {
            field: {
              name: "homeDeliveryReasons",
              type: "number",
              label: "Home Delivery Reasons",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
           //Intervention action place for medical officer
           {
            minWidth:300,
            field: {
              name: "motherDetails_Parameters_Programmes_for_Institutional_Delivery_PID_Intervention_Action_plan_of_Medical_Officer",
              type: "text",
              label: "Intervention Action Plan for Medical Officer",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          // motherDetails_Parameters_Programmes_for_Institutional_Delivery_PID_Is_she_ready_to_deliver_her_baby_at_the_facility
          {
            minWidth: 150,
            field: {
              name: "motherDetails_Parameters_Programmes_for_Institutional_Delivery_PID_Is_she_ready_to_deliver_her_baby_at_the_facility",
              type: "select",
              label: "Ready for delivery",
              option: {
                key: "ReadyForDelivery",
                value: "_id",
                label: "name",
              },
            },
            data: {
              ReadyForDelivery: [
                "Any",
                "Yes",
                "No",
              ].map((d) => {
                if (d === "Any") return { _id: "", name: "Any" };
                return { _id: d, name: d };
              }),
            },
            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          // immunized Reason
          {
            field: {
              name: "immunizeReason",
              type: "text",
              label: "Immunize Reason",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          // otherImmunizeReason
          {
            field: {
              name: "otherImmunizeReason",
              type: "text",
              label: "Other Immunize Reason",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
          // otherHomeDeliveryReason
          {
            field: {
              name: "otherHomeDeliveryReason",
              type: "text",
              label: "Other Home Delivery Reason",
            },

            onChange: (name, value) => {
              filter[name] = value;
              setFilter({ ...filter });
            },
            state: filter,
          },
        ]}
      />
      <Box sx={{ mt: 2 }}>
        <Grid
          data={data}
          columns={[
            { id: "motherId", label: "Mother ID", minWidth: 70 },
            // { id: 'name', label: 'Name', minWidth: 70 },

            { id: "phoneNo", label: "Contact", minWidth: 70 },
            {
              id: "motherDetails_Mother Details_residence District",
              label: "District Name",
              minWidth: 70,
            },
            // { id: 'type', label: 'Type', minWidth: 50 },
            { id: "agent_name", label: "AllocatedTo", minWidth: 70 },
            { id: "callStatus", label: "Status", minWidth: 50 },
            // { id: 'sankalpData', label: 'Trimester', minWidth: 50, format: (data, row)=> {
            //     return data?data.trimester:''
            // } },
            ...Object.keys(sankalpColumnObj).map((key) => {
              // console.log(key,'88888')
              // modifiedLabelWithDot(key)
              return {
                id: key.replaceAll(".", "_"),
                label: modifiedLabelWithDot(key),
                minWidth: [
                  "advice",
                  "comments",
                  "motherDetails_Parameters Programmes for Institutional Delivery_PID_Intervention Action plan of Medical Officer",
                ].includes(key.replaceAll(".", "_"))
                  ? 200
                  : 50,
                format: (data, row) => {
                  if (
                    [
                      "advice",
                      "comments",
                      "motherDetails_Parameters Programmes for Institutional Delivery_PID_Intervention Action plan of Medical Officer",
                    ].includes(key.replaceAll(".", "_"))
                  ) {
                    return (data || "").substring(0, 40) + "....";
                  }
                  return data;
                },
              };
            }),

            {
              id: "callDate",
              label: "Call Date",
              minWidth: 70,
              format: (data, row) => {
                return data ? dayjs(data).format("DD-MM-YYYY") : "";
              },
            },
          ]}
          pagination={{
            rowsPerPageOptions: [10, 25, 50],
            page,
            rowsPerPage,
            onPageChange: (event, newPage) => {
              setPage(newPage);
            },
            onRowsPerPageChange: (event) => {
              setRowsPerPage(+event.target.value);
              setPage(0);
            },
            count,
          }}
        ></Grid>
      </Box>
    </>
  );
};
